import { atom } from 'jotai';
import { CallFiltersState } from '../typings';

export const showCallFiltersAtom = atom<{
  open: boolean;
  state?: CallFiltersState;
}>({
  open: true,
  state: CallFiltersState.NONE,
});

export const waVoiceUpgradeModalOpen = atom(false);

export const waVoiceTrialAutoOpenAtom = atom(false);
